// Context-Objekt + Hook getrennt vom Provider — siehe authContextValue.ts für die Begründung
// (react-refresh/only-export-components: gemischte Exporte kosten den Fast Refresh).
import { createContext } from 'react';

export interface LanguageContextType {
  currentLanguage: string;
  setLanguage: (language: string) => void;
  availableLanguages: { code: string; name: string; flag: string }[];
}

export const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

// Hier stand ein Haken `useLanguage`, der den Context auslas — ohne einen einzigen Aufrufer.
// Er war auch keiner, der noch angeschlossen gehört: eine Sprachumschaltung gibt es in der
// Oberfläche nicht, und die Stellen, die übersetzen (Sidebar, Login, Übersicht), holen sich
// `useTranslation` direkt von react-i18next — der reaktive Weg, den react-i18next selbst
// vorsieht. Der Provider bleibt trotzdem: er stellt die gespeicherte Sprache aus dem
// localStorage wieder her, und diese Wirkung hängt nicht an einem Verbraucher.
